export default "__VITE_ASSET__vupwB_EV__"